import { t } from "i18next";
import { Media } from "./media";

export interface Team {
    id: number;
    name: string;
    club_id: number;
    club_name: string;
    modality_id: number;
    modality_name: string;
    category_id: number;
    category_name: string;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyTeam: Team = {
    id: 0,
    name: '',
    club_id: 0,
    club_name: '',
    modality_id: 0,
    modality_name: '',
    category_id: 0,
    category_name: '',
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}